const ESTONIA_REGION_FILES: Record<string, string> = {
  'Harju maakond': 'Harju_maakond', //
  'Tartu maakond': 'Tartu_maakond', //
  'Ida-Viru maakond': 'Ida_Viru_maakond', //
  'Pärnu maakond': 'P_rnu_maakond', //
  'Rapla maakond': 'Rapla_maakond', //
  'Viljandi maakond': 'Viljandi_maakond', //
  'Lääne-Viru maakond': 'L_ne_Viru_maakond', //
  'Järva maakond': 'J_rva_maakond', //
  'Saare maakond': 'Saare_maakond', //
  'Põlva maakond': 'P_lva_maakond', //
  'Valga maakond': 'Valga_maakond', //
  'Võru maakond': 'V_ru_maakond', //
  'Hiiu maakond': 'Hiiu_maakond', //
  'Jõgeva maakond': 'J_geva_maakond', //
  'Lääne maakond': 'L_ne_maakond', //
};

export { ESTONIA_REGION_FILES };
